import { DispatcherEvent } from '@carvana/merch-native';
import { useCallback, useContext } from 'react';
import { useIsNative } from '~/context/common/DeviceContext';
import GlobalContext from '~/context/vdp/GlobalContext';
import { type PurchaseEventPayload } from '~/native/common/contracts';
import sendPurchaseMessageToNative from './sendPurchaseMessageToNative';

export default function useStartPurchase(
  url: string,
  eventPayload: PurchaseEventPayload
): () => void {
  const isNative = useIsNative();
  const { triggerEvent } = useContext(GlobalContext);

  return useCallback(() => {
    if (isNative) {
      sendPurchaseMessageToNative(DispatcherEvent.StartPurchase, eventPayload);
    } else {
      triggerEvent.purchase();
      window.location.href = url;
    }
  }, [eventPayload, isNative, triggerEvent, url]);
}
